<template>
  <div class="wrapper">
    <section class="interview">
      <div class="container interview__container">
        <div class="interview__content" sticky-container>
          <div class="header_test">
            <div class="interview__block--one">
              <h2 class="interview__recommedations">Рекомендации:</h2>
              <div class="interview__recommedations--item">Будьте честны, даже если некоторые вопросы для вас болезненны!</div>
              <div class="interview__recommedations--item">Будьте внимательны к своим эмоциям в процессе!</div>
              <div class="interview__recommedations--item">Выполняйте рекомендации в конце теста, чтобы повысить свой уровень любовной энергии!</div>
            </div>
          </div>
          <div class="header_test__proccess" v-sticky>
            <div class="interview__line--prog" >
              <span class="progress">{{ percentResult }}%</span>
              <div class="line">
                <span class="line-progress" :style="{width: percentResult + '%'}"></span>
              </div>
            </div>
          </div>
          <form action="#" method="" class="form-interview form">
            <div class="interview__blocks">
              <div class="interview__block--two one" v-show="stage === 'stage-1'">
                <div class="interview__block--item" :class="{ selectedAnswer: result[item.id] }" :id="item.id" v-for="(item, index) in questions['stage-1']">
                  <div class="statement">
                    <h3 class="statement__numbers">{{ item.indexTitle}}</h3>
                    <span class="statement__question" v-html="item.question"></span>
                  </div>
                  <div class="interview__items">
                    <div class="block__item--input" v-for="(answerItem, subindex) in answer" @click="selectAnswerTest(item.id, subindex, parseInt(item.index) + 1, item.index, item.scrolling)">
                      <div class="item__input" :class="[subindex === result[item.id] ? 'active' : '', answerItem.className]"></div>
                      <div class="item__input--text" v-html="answerItem.title"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="interview__block--two two" v-show="stage === 'stage-2'">
                <div class="interview__block--item" :class="{ selectedAnswer: result[item.id] }" :id="item.id" v-for="(item, index) in questions['stage-2']">
                  <div class="statement">
                    <h3 class="statement__numbers">{{ item.indexTitle}}</h3>
                    <span class="statement__question" v-html="item.question"></span>
                  </div>
                  <div class="interview__items">
                    <div class="block__item--input" v-for="(answerItem, subindex) in answer" @click="selectAnswerTest(item.id, subindex, parseInt(item.index) + 1, item.index, item.scrolling)">
                      <div class="item__input" :class="[subindex === result[item.id] ? 'active' : '', answerItem.className]"></div>
                      <div class="item__input--text" v-html="answerItem.title"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="interview__block--two thee" v-show="stage === 'stage-3'">
                <div class="interview__block--item" :class="{ selectedAnswer: result[item.id] }" :id="item.id" v-for="(item, index) in questions['stage-3']">
                  <div class="statement">
                    <h3 class="statement__numbers">{{ item.indexTitle}}</h3>
                    <span class="statement__question" v-html="item.question"></span>
                  </div>
                  <div class="interview__items">
                    <div class="block__item--input" v-for="(answerItem, subindex) in answer" @click="selectAnswerTest(item.id, subindex, parseInt(item.index) + 1, item.index, item.scrolling)">
                      <div class="item__input" :class="[subindex === result[item.id] ? 'active' : '', answerItem.className]"></div>
                      <div class="item__input--text" v-html="answerItem.title"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="interview__block--two four" v-show="stage === 'stage-4'">
                <div class="interview__block--item" :class="{ selectedAnswer: result[item.id] }" :id="item.id" v-for="(item, index) in questions['stage-4']">
                  <div class="statement">
                    <h3 class="statement__numbers">{{ item.indexTitle}}</h3>
                    <span class="statement__question" v-html="item.question"></span>
                  </div>
                  <div class="interview__items">
                    <div class="block__item--input" v-for="(answerItem, subindex) in answer" @click="selectAnswerTest(item.id, subindex, parseInt(item.index) + 1, item.index, item.scrolling)">
                      <div class="item__input" :class="[subindex === result[item.id] ? 'active' : '', answerItem.className]"></div>
                      <div class="item__input--text" v-html="answerItem.title"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="action_btn" style="min-height: 55px; width: 100%; text-align: center">
                <button type="button" class="interview__btn btn btn-reset" @click="nextStage" v-show="stage !== 'stage-4'">
                  Продолжить <img loading="lazy" src="~@/assets/img/svg/stretch-2.svg" class="image" width="33" height="33" alt="stretch" />
                </button>
                <button type="button" class="interview__btn btn btn-reset" @click="showResult" v-show="questionResulted === 20">
                  Продолжить <img loading="lazy" src="~@/assets/img/svg/stretch-2.svg" class="image" width="33" height="33" alt="stretch" />
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section><!-- ANSWWER -- BLOCK one -->
  </div>
</template>

<script>

export default {
  name: "Questions",
  data() {
    return {
      questions: {
        "stage-1": [
          { id: "test-1", index: "1", indexTitle: "01", question: "Когда вы смотрите в зеркало, вы собой не очень довольны", scrolling: true },
          { id: "test-2", index: "2", indexTitle: "02", question: "Вам важно знать все о своем партнере: что он любит, с кем бывает, как отдыхает и даже что думает.", scrolling: true },
          { id: "test-3", index: "3", indexTitle: "03", question: "Вы обычно ругаете себя, если у вас что-то не получается или получается не идеально.", scrolling: true },
          { id: "test-4", index: "4", indexTitle: "04", question: "Вы часто сравниваете свою жизнь с жизнью других людей.", scrolling: true },
          { id: "test-5", index: "5", indexTitle: "05", question: "Вы постоянно ожидаете<br>критики от своих близких<br>(родителей, партнера и др.)<br>и часто получаете ее.", scrolling: false }
        ],
        "stage-2": [
          { id: "test-6", index: "6", indexTitle: "06", question: "У вас нередко случаются перепады настроения, и вы не можете контролировать свои эмоции.", scrolling: true },
          { id: "test-7", index: "7", indexTitle: "07", question: "Большая часть ваших поступков направлена на то, чтобы понравиться другим людям.", scrolling: true },
          { id: "test-8", index: "8", indexTitle: "08", question: "Вам сложно простить человека, и вы долго держите обиды.", scrolling: true },
          { id: "test-9", index: "9", indexTitle: "09", question: "Вы часто меняете партнеров, так как не можете найти достойного.", scrolling: true },
          { id: "test-10", index: "10", indexTitle: "10", question: "Во всех ваших отношениях присутствует один и тот же сценарий, который вас не устраивает.", scrolling: false }
        ],
        "stage-3": [
          { id: "test-11", index: "11", indexTitle: "11", question: "Вам часто приходится откладывать свои цели и мечты ради бытовых дел или проблем других людей.", scrolling: true },
          { id: "test-12", index: "12", indexTitle: "12", question: "Вы скорее ревнивый человек, и вам сложно доверять людям.", scrolling: true },
          { id: "test-13", index: "13", indexTitle: "13", question: "В отношениях вас все время хотят изменить или “улучшить”.", scrolling: true },
          { id: "test-14", index: "14", indexTitle: "14", question: "Вы замечаете, что очень часто обстоятельства складываются против вас.", scrolling: true },
          { id: "test-15", index: "15", indexTitle: "15", question: "Вам кажется, что вы в чем-то превосходите других людей.", scrolling: false }
        ],
        "stage-4": [
          { id: "test-16", index: "16", indexTitle: "16", question: "Вы часто чувствуете, что вам надо оправдываться перед окружающими.", scrolling: true },
          { id: "test-17", index: "17", indexTitle: "17", question: "Вам не нравится быть в центре внимания.", scrolling: true },
          { id: "test-18", index: "18", indexTitle: "18", question: "Вы часто завидуете другим.", scrolling: true },
          { id: "test-19", index: "19", indexTitle: "19", question: "Во время близости вы не можете полностью расслабиться и не думать о том, как выглядите со стороны.", scrolling: true },
          { id: "test-20", index: "20", indexTitle: "20", question: "Вы считаете, что в жизни может быть только одна любовь.", scrolling: false }
        ]
      },
      answer: {
        one: { title: "Согласен", ball: 1, className: "input--item-1" },
        two: { title: "Скорее<br>согласен", ball: 2, className: "input--item-2" },
        three: { title: "Скорее<br>не согласен", ball: 3, className: "input--item-3" },
        four: { title: "Не согласен", ball: 4, className: "input--item-4" }
      },
      result: {
        "test-1": null,
        "test-2": null,
        "test-3": null,
        "test-4": null,
        "test-5": null,
        "test-6": null,
        "test-7": null,
        "test-8": null,
        "test-9": null,
        "test-10": null,
        "test-11": null,
        "test-12": null,
        "test-13": null,
        "test-14": null,
        "test-15": null,
        "test-16": null,
        "test-17": null,
        "test-18": null,
        "test-19": null,
        "test-20": null
      },
      countResult: 0,
      stage: "stage-1"
    }
  },
  computed: {
    percentResult() {
      return 5 * this.questionResulted
    },
    questionResulted() {
      let result = 0;
      for (let item in this.result) this.result[item] && result++;
      return result
    }
  },
  methods: {
    selectAnswerTest(id, ball, next, currentIndex, scrolling = true) {
      if (next <= 20) {
        let item = document.getElementById("test-" + next);
        if (item && scrolling) {
          let top = window.scrollY + item.getBoundingClientRect().top;
          window.scrollTo(0, top - 355)
        }
        else {
          setTimeout(() => {
            let btn = document.getElementById("action_btn");
            let top = window.scrollY + btn.getBoundingClientRect().top;
            window.scrollTo(0, top - 355)
          }, 100)
        }
      }
      else {
        setTimeout(() => {
          let btn = document.getElementById("action_btn");
          let top = window.scrollY + btn.getBoundingClientRect().top;
          window.scrollTo(0, top - 355)
        }, 100)
      }
      return this.result[id] = ball, ym(56736205, "reachGoal", "q" + currentIndex)
    },
    showResult() {
      let result = 0;
      for (let item in this.result) {
        if (!this.result[item]) {
          let itemTest = document.getElementById(item), top = window.scrollY + itemTest.getBoundingClientRect().top;
          return window.scrollTo(0, top - 100)
        }
        result += parseInt(this.answer[this.result[item]].ball)
      }
      ym(56736205,'reachGoal','resultlovetest')
      this.countResult = result, result >= 20 && result <= 30 ? this.$router.push("/result-1") : result >= 31 && result <= 45 ? this.$router.push("/result-2") : result >= 46 && result <= 55 ? this.$router.push("/result-3") : result >= 56 && result <= 65 ? this.$router.push("/result-4") : result >= 66 && result <= 72 ? this.$router.push("/result-5") : result >= 73 && result <= 80 && this.$router.push("/result-6")
    },
    nextStage() {
      for (let A of this.questions[this.stage]) if (!this.result[A.id]) {
        let t = document.getElementById(A.id);
        let e = window.scrollY + t.getBoundingClientRect().top;
        return window.scrollTo(0, e - 355)
      }
      switch (this.stage) {
        case"stage-1":
          this.stage = "stage-2";
          break;
        case"stage-2":
          this.stage = "stage-3";
          break;
        case"stage-3":
          this.stage = "stage-4";
          break
      }
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 100)
    },
    ymClick(id) {
      return ym(56736205, "reachGoal", "q" + id)
    }
  }
}
</script>